/**
 * Aarogya CBD - Certified Medical Cannabis Doctors & Specialists Database
 * High-resolution local portraits, clinical specializations, consultation fees, and available booking slots.
 */
window.AarogyaCBDDoctorsData = [
  {
    "id": "dr-abdul-shafiz-shaikh",
    "name": "Dr. Abdul Shafiz Shaikh",
    "title": "Unani & Cannabis Medical Specialist",
    "degree": "B.U.M.S",
    "regNo": "I-2416",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 142,
    "experience": "8+ Years",
    "languages": [
      "English",
      "Hindi",
      "Urdu"
    ],
    "specialty": "Unani Medicine & Medical Cannabis",
    "specialtiesList": [
      "Chronic Pain",
      "Insomnia & Sleep",
      "General Wellness",
      "Anxiety & Stress"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2021/11/Dr.-A.S.-Shaikh.png",
    "bio": "Dr. Abdul Shafiz Shaikh is a renowned Unani medicine practitioner specializing in cannabinoid-based therapy. With over 8 years of clinical experience, Dr. Shaikh combines classical Unani principles with modern Ayurvedic cannabis formulations to treat chronic pain, insomnia, and anxiety disorders effectively.",
    "education": "Bachelor of Unani Medicine and Surgery (B.U.M.S)",
    "location": "Mumbai, Maharashtra",
    "nextAvailableSlot": "Today at 04:30 PM",
    "slots": {
      "morning": [
        "10:00 AM",
        "11:00 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "03:30 PM",
        "04:30 PM"
      ],
      "evening": [
        "06:00 PM",
        "07:00 PM",
        "08:00 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Abdul_Shafiz_Shaikh_Degree_Certificate.pdf?v=1791396451",
    "degreeFile": "dr-abdul-shafiz-shaikh-degree.pdf"
  },
  {
    "id": "dr-sivaram",
    "name": "Dr. Sivaram",
    "title": "Ayurvedic Physician & Medical Cannabis Expert",
    "degree": "B.A.M.S, MD Ayurveda",
    "regNo": "0416009",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 189,
    "experience": "10+ Years",
    "languages": [
      "English",
      "Hindi",
      "Tamil"
    ],
    "specialty": "Pain Management & Internal Medicine",
    "specialtiesList": [
      "Arthritis & Joint Pain",
      "Neurological Disorders",
      "Digestive Health",
      "Chronic Pain"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2021/12/Dr.-Sivaram-B.A.M.S.jpg",
    "bio": "Dr. Sivaram holds an MD in Ayurveda with deep clinical focus on Vijaya (Cannabis sativa L.) applications for severe joint inflammation, nerve pain, and digestive ailments. He has consulted over 5,000 patients across India.",
    "education": "B.A.M.S, MD (Ayurveda)",
    "location": "Chennai, Tamil Nadu",
    "nextAvailableSlot": "Today at 05:00 PM",
    "slots": {
      "morning": [
        "10:30 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "01:30 PM",
        "03:00 PM",
        "05:00 PM"
      ],
      "evening": [
        "06:30 PM",
        "07:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Sivaram_Degree_Certificate.pdf?v=1791396531",
    "degreeFile": "dr-sivaram-degree.pdf"
  },
  {
    "id": "vaidya-naveen-sharma",
    "name": "Vaidya Naveen Sharma",
    "title": "Senior Ayurvedic Consultant & Cannabinoid Expert",
    "degree": "B.A.M.S",
    "regNo": "DBCP/A/6241",
    "fee": 500,
    "rating": 5,
    "reviewsCount": 210,
    "experience": "12+ Years",
    "languages": [
      "English",
      "Hindi"
    ],
    "specialty": "Classical Ayurveda & Cannabinoid Therapy",
    "specialtiesList": [
      "Severe Stress & Anxiety",
      "Pancarkarma Guidance",
      "Oncology Palliative Care",
      "Sleep Therapy"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2021/11/Dr.-Naveen-Sharma-BAMS.png-min.png",
    "bio": "Vaidya Naveen Sharma is an esteemed Ayurvedic physician with over 12 years of expertise in integrating classical Vijaya formulations into modern therapeutic protocols for chronic stress, palliative care, and sleep disorders.",
    "education": "B.A.M.S (Ayurvedacharya)",
    "location": "New Delhi, Delhi",
    "nextAvailableSlot": "Tomorrow at 11:00 AM",
    "slots": {
      "morning": [
        "11:00 AM",
        "12:00 PM"
      ],
      "afternoon": [
        "02:30 PM",
        "04:00 PM"
      ],
      "evening": [
        "05:30 PM",
        "07:00 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Naveen_Sharma_Degree_Certificate.pdf?v=1791396501",
    "degreeFile": "vaidya-naveen-sharma-degree.pdf"
  },
  {
    "id": "dr-sankalp-khullar",
    "name": "Dr. Sankalp Khullar",
    "title": "Ayurveda & Panchkarma Specialist",
    "degree": "BAMS (Ayurveda & Panchkarma Expert)",
    "regNo": "30692",
    "fee": 200,
    "rating": 5,
    "reviewsCount": 175,
    "experience": "7+ Years",
    "languages": [
      "English",
      "Hindi",
      "Punjabi"
    ],
    "specialty": "Panchkarma & Stress Management",
    "specialtiesList": [
      "Insomnia & Sleep",
      "Anxiety & Stress",
      "Detox & Panchkarma",
      "General Wellness"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2024/11/Dr.-Sankalp-Khullar.jpg",
    "bio": "Dr. Sankalp Khullar specializes in Panchkarma therapies and restorative Ayurvedic medicine. He utilizes tailored CBD oil and full spectrum extracts to restore dosha balance and ease stress-induced fatigue.",
    "education": "B.A.M.S (Ayurveda & Panchkarma)",
    "location": "Chandigarh",
    "nextAvailableSlot": "Today at 06:00 PM",
    "slots": {
      "morning": [
        "09:30 AM",
        "10:30 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "04:00 PM"
      ],
      "evening": [
        "06:00 PM",
        "07:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Sankalp_Khullar_Degree_Certificate.pdf?v=1791396511",
    "degreeFile": "dr-sankalp-khullar-degree.pdf"
  },
  {
    "id": "dr-shruti-sridhar",
    "name": "Dr. Shruti Sridhar",
    "title": "Holistic Health Specialist",
    "degree": "MBBS, M.P.H, MF(Hom)",
    "regNo": "151264",
    "fee": 500,
    "rating": 5,
    "reviewsCount": 168,
    "experience": "9+ Years",
    "languages": [
      "English",
      "Hindi",
      "Kannada"
    ],
    "specialty": "Holistic Medicine & Integrative Health",
    "specialtiesList": [
      "Lifestyle Disorders",
      "Women's Wellness",
      "Chronic Fatigue",
      "Anxiety & Stress"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2023/02/Dr.-Shruti-Sridhar.png",
    "bio": "Dr. Shruti Sridhar combines an MBBS background with a Master\u2019s in Public Health and Homeopathy to offer evidence-informed integrative medical cannabis care, focusing on lifestyle transformation and wellness.",
    "education": "MBBS, M.P.H (USA), MF(Hom)",
    "location": "Bengaluru, Karnataka",
    "nextAvailableSlot": "Tomorrow at 02:00 PM",
    "slots": {
      "morning": [
        "10:00 AM",
        "11:00 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "03:30 PM"
      ],
      "evening": [
        "05:00 PM",
        "06:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Shruti_Sridhar_Degree_Certificate.pdf?v=1791396525",
    "degreeFile": "dr-shruti-sridhar-degree.pdf"
  },
  {
    "id": "dr-vaibhav-mishra",
    "name": "Dr. Vaibhav Mishra",
    "title": "Ayurvedic Surgeon & Vedic Science Specialist",
    "degree": "B.A.M.S, MS (General Surgery), CCPA, Ph.D. Vedic Science",
    "regNo": "RBMS-CG-882",
    "fee": 500,
    "rating": 5,
    "reviewsCount": 230,
    "experience": "14+ Years",
    "languages": [
      "English",
      "Hindi"
    ],
    "specialty": "Surgical & Chronic Pain Management",
    "specialtiesList": [
      "Post-Surgical Recovery",
      "Severe Neuropathy",
      "Spinal Pain",
      "Chronic Pain"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2023/04/Dr.-Vaibhav-Mishra.png",
    "bio": "Dr. Vaibhav Mishra is an Ayurvedic Surgeon with a Ph.D. in Vedic Science and Master NLP certification. He specializes in advanced pain management using high-potency Vijaya formulations for post-surgical and neuropathic pain.",
    "education": "B.A.M.S, MS (Surgery), Ph.D. Vedic Science, CCPA",
    "location": "Raipur, Chhattisgarh",
    "nextAvailableSlot": "Today at 03:30 PM",
    "slots": {
      "morning": [
        "11:00 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "03:30 PM",
        "04:30 PM"
      ],
      "evening": [
        "06:00 PM",
        "07:00 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Vaibhav_Mishra_Degree_Certificate.pdf?v=1791396538",
    "degreeFile": "dr-vaibhav-mishra-degree.pdf"
  },
  {
    "id": "dr-kapil-saini",
    "name": "Dr. Kapil Saini",
    "title": "Integrative Ayurvedic Practitioner",
    "degree": "B.A.M.S",
    "regNo": "26142",
    "fee": 500,
    "rating": 5,
    "reviewsCount": 154,
    "experience": "8+ Years",
    "languages": [
      "English",
      "Hindi"
    ],
    "specialty": "Lifestyle & Autoimmune Care",
    "specialtiesList": [
      "Autoimmune Conditions",
      "Chronic Inflammation",
      "Stress Management",
      "General Wellness"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2021/11/Dr.-Kapil-Saini-B.A.M.S.png",
    "bio": "Dr. Kapil Saini provides comprehensive medical cannabis consultations focusing on inflammatory disorders, autoimmune management, and stress-related hormonal imbalances.",
    "education": "B.A.M.S",
    "location": "Jaipur, Rajasthan",
    "nextAvailableSlot": "Today at 04:00 PM",
    "slots": {
      "morning": [
        "10:00 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "02:30 PM",
        "04:00 PM"
      ],
      "evening": [
        "06:00 PM",
        "07:00 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Kapil_Saini_Degree_Certificate.pdf?v=1791396478",
    "degreeFile": "dr-kapil-saini-degree.pdf"
  },
  {
    "id": "dr-mariya-parvez",
    "name": "Dr. Mariya Parvez",
    "title": "Ayurvedic Women's Health & Mental Wellness Expert",
    "degree": "B.A.M.S",
    "regNo": "DBCP/A/8914",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 198,
    "experience": "6+ Years",
    "languages": [
      "English",
      "Hindi"
    ],
    "specialty": "Women's Health & Mental Wellness",
    "specialtiesList": [
      "PCOS & Hormonal Pain",
      "Anxiety & Mood Swings",
      "Sleep & Fatigue",
      "Skin Disorders"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2025/03/Dr.Mariya-Parvez-250x250-1.png",
    "bio": "Dr. Mariya Parvez is an expert in female reproductive health and stress disorders. She crafts gentle yet effective cannabinoid care plans for menstrual cramps, PCOS symptoms, and mood regulation.",
    "education": "B.A.M.S",
    "location": "Delhi NCR",
    "nextAvailableSlot": "Today at 05:30 PM",
    "slots": {
      "morning": [
        "10:30 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "01:30 PM",
        "03:00 PM",
        "05:30 PM"
      ],
      "evening": [
        "06:30 PM",
        "07:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Kapil_Saini_Degree_Certificate.pdf?v=1791396478",
    "degreeFile": "dr-mariya-parvez-degree.pdf"
  },
  {
    "id": "dr-prashant-jain",
    "name": "Dr. Prashant Jain",
    "title": "Ayurvedic Cannabinoid Specialist",
    "degree": "B.A.M.S",
    "regNo": "DBCP/A/8534",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 136,
    "experience": "7+ Years",
    "languages": [
      "English",
      "Hindi"
    ],
    "specialty": "Metabolic & Pain Care",
    "specialtiesList": [
      "Metabolic Disorders",
      "Chronic Back Pain",
      "Insomnia",
      "Digestive Health"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2022/05/Dr.-Prashant-Jain.png",
    "bio": "Dr. Prashant Jain specializes in chronic musculoskeletal pain and metabolic health management through standardized plant-based cannabinoids.",
    "education": "B.A.M.S",
    "location": "Indore, Madhya Pradesh",
    "nextAvailableSlot": "Tomorrow at 10:00 AM",
    "slots": {
      "morning": [
        "10:00 AM",
        "11:00 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "03:30 PM"
      ],
      "evening": [
        "05:30 PM",
        "07:00 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Prashant_Jain_Degree_Certificate.pdf?v=1791396506",
    "degreeFile": "dr-prashant-jain-degree.pdf"
  },
  {
    "id": "dr-ankur-kumar-tanwar",
    "name": "Dr. Ankur Kumar Tanwar",
    "title": "Ayurvedic Physician & Clinical Researcher",
    "degree": "B.A.M.S, MD",
    "regNo": "DBCP/A/7656",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 184,
    "experience": "9+ Years",
    "languages": [
      "English",
      "Hindi"
    ],
    "specialty": "Ayurvedic Pharmacology & Pain",
    "specialtiesList": [
      "Severe Migraine",
      "Spondylitis",
      "Chronic Inflammation",
      "Sleep Therapy"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2022/05/Dr.-Ankur-Kumar-Tanwar.png",
    "bio": "Dr. Ankur Kumar Tanwar holds an MD in Ayurvedic medicine, focusing on pharmacology and plant tincture interactions for severe migraines and spondylitis.",
    "education": "B.A.M.S, MD (Ayurveda)",
    "location": "Gurugram, Haryana",
    "nextAvailableSlot": "Today at 04:00 PM",
    "slots": {
      "morning": [
        "11:00 AM"
      ],
      "afternoon": [
        "02:30 PM",
        "04:00 PM",
        "05:00 PM"
      ],
      "evening": [
        "06:30 PM",
        "07:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Ankur_Kumar_Tanwar_Degree_Certificate.pdf?v=1791396456",
    "degreeFile": "dr-ankur-kumar-tanwar-degree.pdf"
  },
  {
    "id": "dr-sheetal-amit-sethi",
    "name": "Dr. Sheetal Amit Sethi",
    "title": "Acupuncture & Ayurvedic Specialist",
    "degree": "BAMS, PGPP, D.Acupuncture",
    "regNo": "L-42075-A-1",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 167,
    "experience": "10+ Years",
    "languages": [
      "English",
      "Hindi",
      "Marathi"
    ],
    "specialty": "Acupuncture & Joint Pain",
    "specialtiesList": [
      "Arthritis",
      "Sciatica",
      "Acupuncture Therapy",
      "Stress & Anxiety"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2022/11/Dr.Sheetal-Amit-Sethi.png",
    "bio": "Dr. Sheetal Amit Sethi integrates Acupuncture and Ayurvedic pharmacology with CBD applications to offer holistic relief from sciatica, joint degeneration, and stress.",
    "education": "B.A.M.S, PGPP, Diploma in Acupuncture",
    "location": "Nagpur, Maharashtra",
    "nextAvailableSlot": "Tomorrow at 11:30 AM",
    "slots": {
      "morning": [
        "10:00 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "03:30 PM"
      ],
      "evening": [
        "05:30 PM",
        "07:00 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Sheetal_Amit_Sethi_Degree_Certificate.pdf?v=1791396520",
    "degreeFile": "dr-sheetal-amit-sethi-degree.pdf"
  },
  {
    "id": "dr-nafees-ahmed",
    "name": "Dr. Nafees Ahmed",
    "title": "Ayurvedic Wellness Physician",
    "degree": "B.A.M.S",
    "regNo": "61489",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 148,
    "experience": "8+ Years",
    "languages": [
      "English",
      "Hindi"
    ],
    "specialty": "General Ayurvedic Care & Wellness",
    "specialtiesList": [
      "General Wellness",
      "Digestive Care",
      "Sleep Regulation",
      "Stress & Fatigue"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2021/12/Dr.-Nafees-Ahmed-.jpg",
    "bio": "Dr. Nafees Ahmed provides patient-centered Ayurvedic medical consultation for overall wellness, digestive rehabilitation, and stress relief.",
    "education": "B.A.M.S",
    "location": "Lucknow, Uttar Pradesh",
    "nextAvailableSlot": "Today at 05:00 PM",
    "slots": {
      "morning": [
        "10:30 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "03:30 PM",
        "05:00 PM"
      ],
      "evening": [
        "06:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Nafees_Ahmed_Degree_Certificate.pdf?v=1791396489",
    "degreeFile": "dr-nafees-ahmed-degree.pdf"
  },
  {
    "id": "dr-farhan-nadaf",
    "name": "Dr. Farhan Nadaf",
    "title": "Integrative Homeopathic & Cannabis Specialist",
    "degree": "B.H.M.S",
    "regNo": "61489",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 139,
    "experience": "7+ Years",
    "languages": [
      "English",
      "Hindi",
      "Marathi"
    ],
    "specialty": "Integrative Medicine & Anxiety",
    "specialtiesList": [
      "Anxiety & Panic",
      "Chronic Insomnia",
      "Skin Allergies",
      "Pain Care"
    ],
    "image": "https://www.aarogyacbd.com/wp-content/uploads/2021/11/Dr.-Farhan-Nadaf-B.H.M.S.png",
    "bio": "Dr. Farhan Nadaf incorporates homeopathy and medical cannabis to treat anxiety disorders, panic conditions, and chronic insomnia safely.",
    "education": "B.H.M.S",
    "location": "Kolhapur, Maharashtra",
    "nextAvailableSlot": "Today at 06:30 PM",
    "slots": {
      "morning": [
        "11:00 AM"
      ],
      "afternoon": [
        "02:30 PM",
        "04:00 PM"
      ],
      "evening": [
        "06:30 PM",
        "07:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Farhan_Nadaf_Degree_Certificate.pdf?v=1791396462",
    "degreeFile": "dr-farhan-nadaf-degree.pdf"
  },
  {
    "id": "dr-harshal-sawarkar-bams-ayurvedic-physician",
    "name": "Dr. Harshal Sawarkar",
    "title": "Ayurvedic Physician & Cannabis Medical Expert",
    "degree": "B.A.M.S",
    "regNo": "I-89241-A",
    "fee": 300,
    "rating": 5,
    "reviewsCount": 156,
    "experience": "7+ Years",
    "languages": [
      "English",
      "Hindi",
      "Marathi"
    ],
    "specialty": "Ayurvedic Medicine & Medical Cannabis",
    "specialtiesList": [
      "Chronic Pain",
      "Skin & Hair Disorders",
      "Digestive Health",
      "Anxiety & Insomnia"
    ],
    "image": "dr-harshal-sawarkar.png",
    "bio": "Dr. Harshal Sawarkar is a BAMS Ayurvedic Physician graduated from Ayurved College, Yavatmal, Maharashtra. He specializes in evidence-informed Ayurvedic consultations with a strong focus on Vijaya (medical cannabis) based formulations, treating root causes of chronic pain, skin & hair disorders, anxiety, and digestive issues.",
    "education": "Bachelor of Ayurvedic Medicine and Surgery (B.A.M.S) \u2022 Ayurved College, Yavatmal, Maharashtra",
    "location": "Maharashtra, India",
    "nextAvailableSlot": "Today at 04:00 PM",
    "slots": {
      "morning": [
        "10:00 AM",
        "11:30 AM"
      ],
      "afternoon": [
        "02:00 PM",
        "03:30 PM",
        "04:00 PM"
      ],
      "evening": [
        "06:00 PM",
        "07:30 PM"
      ]
    },
    "degreeUrl": "https://cdn.shopify.com/s/files/1/0810/5397/4727/files/Dr_Harshal_Sawarkar_Degree_Certificate.pdf?v=1791396473",
    "degreeFile": "dr-harshad-jain-degree.pdf"
  }
];

// Ensure local Shopify CDN asset image and degree mapping is attached to every doctor object
if (window.AarogyaCBDDoctorImages || window.AarogyaCBDDoctorDegrees) {
  window.AarogyaCBDDoctorsData.forEach(function(doc) {
    if (window.AarogyaCBDDoctorImages && window.AarogyaCBDDoctorImages[doc.id]) {
      doc.image = window.AarogyaCBDDoctorImages[doc.id];
    }
    if (window.AarogyaCBDDoctorDegrees && window.AarogyaCBDDoctorDegrees[doc.id]) {
      doc.degreeUrl = window.AarogyaCBDDoctorDegrees[doc.id];
    }
  });
}
